import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SiteSettings } from '../dto/response/site.settings';

@Injectable({
  providedIn: 'root',
})
export class SiteSettingService {
  constructor(private http: HttpClient) {}

  fetchSiteSetting(): Observable<SiteSettings> {
    return this.http
      .get<SiteSettings>(`${environment.baseURL}${environment.SITE_SETTING}`)
      .pipe(finalize(() => {}));
  }
}
